import clipperCargas from '../../config/clipperMenus.cargas.js';
import clipperTesoreria from '../../config/clipperMenus.tesoreria.js';

const menuBaseData = {
  Administración: [
    { type: 'link', iconKey: 'administracion', label: 'Administración', to: '/administracion' },
    {
      type: 'section',
      iconKey: 'usuarios',
      label: 'Clientes',
      items: [
        { label: 'Listado', to: '/clientes', iconKey: 'usuarios' },
        { label: 'Nuevo', to: '/clientes/nuevo', iconKey: 'userPlus' },
        /* ✨ ELIMINADO "Clientes (Admin)" - Se unificó el flujo de alta de clientes.
           Antes existían dos flujos: uno en /clientes (sin AFIP) y otro en /admin/clientes (con AFIP).
           Ahora TODOS los flujos usan /clientes/nuevo con validación AFIP/ARCA obligatoria.
           La ruta /admin/clientes se mantiene funcional internamente pero NO se muestra en el menú. */
      ],
    },
    {
      type: 'section',
      iconKey: 'proveedores',
      label: 'Proveedores',
      items: [
        { label: 'Listado', to: '/admin/proveedores', iconKey: 'proveedores' },
        { label: 'Nuevo', to: '/admin/proveedores/nuevo', iconKey: 'userPlus' },
      ],
    },
    {
      type: 'section',
      iconKey: 'vehiculos',
      label: 'Flota',
      items: [
        { label: 'Vehículos', to: '/administracion/flota', iconKey: 'vehiculos' },
        { label: 'Asignaciones', to: '/administracion/flota/asignaciones', iconKey: 'lista' },
      ],
    },
    {
      type: 'section',
      iconKey: 'choferes',
      label: 'Choferes',
      items: [
        { label: 'Listado', to: '/administracion/choferes', iconKey: 'choferes' },
        { label: 'Nuevo', to: '/administracion/choferes/nuevo', iconKey: 'userPlus' },
      ],
    },
    {
      type: 'section',
      iconKey: 'ajustes',
      label: 'Configuración',
      items: [
        { label: 'Tarifas', to: '/tarifas', iconKey: 'ajustes' },
        { label: 'Etiquetas ZPL', to: '/administracion/etiquetas-zpl', iconKey: 'etiquetas' },
        { label: 'Envases', to: '/tablas/descripcion-de-envases', iconKey: 'lista' },
      ],
    },
  ],
  Seguridad: [
    { type: 'link', iconKey: 'usuarios', label: 'Panel', to: '/gerencial/seguridad' },
    { type: 'link', iconKey: 'agenda', label: 'Chat interno', to: '/chat' },
    { type: 'link', iconKey: 'ajustes', label: 'Roles y permisos', to: '/gerencial/roles' },
    { type: 'link', iconKey: 'usuarios', label: 'Sesiones activas', to: '/gerencial/sesiones' },
    { type: 'link', iconKey: 'lista', label: 'Auditoría', to: '/gerencial/auditoria' },
  ],
  Cargas: [
    { type: 'link', iconKey: 'dashboard', label: 'Dashboard de Cargas', to: '/cargas/dashboard' },
    { type: 'link', iconKey: 'alertas', label: 'Inteligencia Operativa', to: '/operaciones/inteligencia' },
    { type: 'link', iconKey: 'retiros', label: 'Retiros', to: '/retiros' },
    {
      type: 'section',
      iconKey: 'guias',
      label: 'Guías',
      items: [
        { label: 'Emisión de Guía', to: '/guias/emitir', iconKey: 'filePlus' },
        { label: 'Consultar Guías', to: '/guias/consulta', iconKey: 'busqueda' },
        { label: 'Buscar Guías', to: '/guias/buscar', iconKey: 'busqueda' },
      ],
    },
    {
      type: 'section',
      iconKey: 'etiquetas',
      label: 'Etiquetas',
      items: [
        { label: 'Nueva Etiqueta', to: '/cargas/etiquetas/nueva', iconKey: 'filePlus' },
        { label: 'Listar Etiquetas', to: '/cargas/etiquetas', iconKey: 'lista' },
      ],
    },
    {
      type: 'section',
      iconKey: 'lineas',
      label: 'Líneas',
      items: [
        { label: 'Crear Línea', to: '/lineas/nueva', iconKey: 'filePlus' },
        { label: 'Listar Líneas', to: '/lineas', iconKey: 'lista' },
      ],
    },
    {
      type: 'section',
      iconKey: 'rutas',
      label: 'Distribución',
      items: [
        { label: 'Emitir Hoja de Ruta', to: '/fojas/emision', iconKey: 'filePlus' },
        { label: 'Consultar Fojas de Ruta', to: '/cargas/fojas-de-ruta', iconKey: 'lista', featureCode: 'jet.cargas.fojas_ruta' },
        { label: 'Repartos', to: '/repartos', iconKey: 'repartos' },
        { label: 'Estadísticas de repartos', to: '/repartos/estadisticas', iconKey: 'dashboard' },
        { label: 'Documentación por Bolsa', to: '/cargas/documentacion-por-bolsa', iconKey: 'guias' },
      ],
    },
    {
      type: 'section', iconKey: 'dashboard', label: 'Retornables', permissions: 'RETORNABLES_VER',
      items: [
        { label: 'Cuenta corriente', to: '/cargas/retornables', iconKey: 'lista', permissions: 'RETORNABLES_VER' },
        { label: 'Por ubicación', to: '/cargas/retornables/ubicaciones', iconKey: 'rutas', permissions: 'RETORNABLES_VER' },
        { label: 'Nuevo movimiento', to: '/cargas/retornables/nuevo', iconKey: 'filePlus', permissions: 'RETORNABLES_REGISTRAR' },
      ],
    },
  ],
  Facturación: [
    { type: 'link', iconKey: 'files', label: 'Consulta de Facturas', to: '/facturacion', permissions: 'FACTURACION_VER' },
    { type: 'link', iconKey: 'filePlus', label: 'Facturas Automáticas', to: '/facturacion/desde-guias', permissions: 'FACTURACION_GENERAR_DESDE_GUIAS' },
    { type: 'link', iconKey: 'filePlus', label: 'Pendientes de Contado', to: '/facturacion/pendientes-contado', permissions: 'FACTURACION_GENERAR_DESDE_GUIAS' },
    { type: 'link', iconKey: 'manual', label: 'Factura Manual', to: '/facturacion/manual/nueva', permissions: 'FACTURACION_GENERAR' },
    { type: 'link', iconKey: 'ajustes', label: 'Diseño de Impresión', to: '/facturacion/configuracion' },
  ],
  Tesorería: [
    { type: 'link', iconKey: 'tesoreria', label: 'Tablero', to: '/tesoreria' },
    {
      type: 'section',
      iconKey: 'cobros',
      label: 'Cobranzas',
      items: [
        { label: 'Minutas', to: '/tesoreria/minutas', iconKey: 'agenda' },
        { label: 'Cobranzas', to: '/tesoreria/cobranzas', iconKey: 'agenda' },
        { label: 'Registrar Cobranza', to: '/tesoreria/cobranzas/nueva', iconKey: 'registrar' },
        { label: 'Recibos', to: '/tesoreria/recibos', iconKey: 'comprobantes', permissions: 'COBRANZAS_VER' },
        { label: 'Rendiciones', to: '/tesoreria/cobranzas/rendicion-de-cobranzas', iconKey: 'historial', permissions: ['COBRANZAS_RENDIR', 'COBRANZAS_RECIBIR_TESORERIA'] },
        { label: 'Cheques recibidos', to: '/tesoreria/cartera-cheques', iconKey: 'lista' },
      ],
    },
    {
      type: 'section',
      iconKey: 'pagos',
      label: 'Pagos',
      items: [
        { label: 'Historial de Pagos', to: '/tesoreria/pagos', iconKey: 'historial' },
      ],
    },
    {
      type: 'section',
      iconKey: 'compras',
      label: 'Compras',
      items: [
        { label: 'Registro de Compras', to: '/tesoreria/compras', iconKey: 'compras' },
        { label: 'Nueva Compra', to: '/tesoreria/compras/nueva', iconKey: 'filePlus' },
        { label: 'Carga Masiva de Facturas', to: '/tesoreria/compras/carga-masiva', iconKey: 'upload' },
      ],
    },
  ],
  Gerencial: [
    {
      type: 'section',
      iconKey: 'dashboard',
      label: 'Visión Gerencial',
      items: [
        { label: 'Dashboard', to: '/gerencial/dashboard', iconKey: 'dashboard' },
        { label: 'Panel Ejecutivo', to: '/finanzas/ejecutivo', iconKey: 'reportes' },
        { label: 'Alertas', to: '/gerencial/alertas', iconKey: 'alertas' },
        { label: 'Reportes', to: '/gerencial/reportes', iconKey: 'reportes' },
      ],
    },
    { type: 'link', iconKey: 'ajustes', label: 'Políticas operativas de fojas', to: '/gerencial/configuracion/fojas', permissions: ['FOJAS_CONFIGURAR_POLITICAS'] },
    {
      type: 'section',
      iconKey: 'administracion',
      label: 'Empresa y fiscal',
      featureCode: 'GERENCIAL.EMPRESA_FISCAL',
      items: [
        { label: 'Sucursales de la empresa', to: '/administracion/empresa/sucursales-de-la-empresa', iconKey: 'administracion' },
        { label: 'Localidades atendidas', to: '/administracion/empresa/localidades-atendidas', iconKey: 'administracion' },
        { label: 'Empresas de redespacho', to: '/administracion/redespachos', iconKey: 'administracion' },
        { label: 'Rutas de distribución', to: '/administracion/empresa/rutas-de-distribucion', iconKey: 'administracion' },
        { label: 'Plantilla de impresión de guías', to: '/administracion/empresa/plantilla-de-impresion-de-guias', iconKey: 'administracion' },
        { label: 'Correo de facturas', to: '/administracion/empresa/correo-de-facturas', iconKey: 'facturacion' },
        { label: 'Certificados de factura electrónica', to: '/administracion/afip-e-impuestos/certificados-de-factura-electronica', iconKey: 'facturacion' },
        { label: 'Puntos de venta', to: '/administracion/empresa/puntos-de-venta', iconKey: 'administracion' },
        { label: 'Numeración del sistema', to: '/administracion/empresa/numeracion-del-sistema', iconKey: 'administracion' },
      ],
    },
    {
      type: 'section',
      iconKey: 'usuarios',
      label: 'Seguridad',
      permissions: ['administrar_usuarios'],
      items: [
        { label: 'Panel', to: '/gerencial/seguridad', iconKey: 'dashboard', permissions: ['administrar_usuarios'] },
        { label: 'Usuarios', to: '/gerencial/usuarios', iconKey: 'usuarios', permissions: ['administrar_usuarios'] },
        { label: 'Roles', to: '/gerencial/roles', iconKey: 'ajustes', permissions: ['administrar_roles'] },
        { label: 'Sesiones', to: '/gerencial/sesiones', iconKey: 'usuarios', permissions: ['ver_sesiones'] },
        { label: 'Auditoría', to: '/gerencial/auditoria', iconKey: 'lista', permissions: ['ver_auditoria_seguridad'] },
      ],
    },
  ],
  RRHH: [
    {
      type: 'section',
      iconKey: 'lista',
      label: 'Asistencias',
      items: [
        { label: 'Listado', to: '/rrhh/asistencias', iconKey: 'lista' },
        { label: 'Registrar asistencia', to: '/rrhh/asistencias/nueva', iconKey: 'filePlus' },
      ],
    },
    {
      type: 'section',
      iconKey: 'clock',
      label: 'Turnos',
      items: [
        { label: 'Gestión de turnos', to: '/rrhh/turnos', iconKey: 'clock' },
        { label: 'Nueva asignación', to: '/rrhh/turnos/asignaciones/nueva', iconKey: 'userPlus' },
      ],
    },
    {
      type: 'section',
      iconKey: 'calendar',
      label: 'Vacaciones',
      items: [
        { label: 'Solicitudes', to: '/rrhh/vacaciones', iconKey: 'calendar' },
        { label: 'Nueva solicitud', to: '/rrhh/vacaciones/nueva', iconKey: 'filePlus' },
      ],
    },
  ],
  Almacenaje: [
    { type: 'link', iconKey: 'stock', label: 'Visión General', to: '/stock', permissions: 'STOCK_VER' },
    { type: 'link', iconKey: 'busqueda', label: 'Consulta de stock', to: '/stock/consulta', permissions: 'STOCK_VER' },
    { type: 'link', iconKey: 'depositos', label: 'Ubicaciones', to: '/stock/ubicaciones', permissions: 'STOCK_UBICACIONES_ADMIN' },
    { type: 'link', iconKey: 'inventario', label: 'Inventario', to: '/stock/inventarios', permissions: 'STOCK_VER' },
    { type: 'link', iconKey: 'lista', label: 'Kardex', to: '/stock/kardex', permissions: 'STOCK_VER' },
    { type: 'section', iconKey: 'inventario', label: 'Entradas y salidas', items: [
      { label: 'Nueva entrada', to: '/stock/entradas/nueva', iconKey: 'filePlus', permissions: 'STOCK_ENTRADA' },
      { label: 'Entradas', to: '/stock/entradas', iconKey: 'lista', permissions: 'STOCK_VER' },
      { label: 'Nueva salida', to: '/stock/salidas/nueva', iconKey: 'filePlus', permissions: 'STOCK_SALIDA' },
      { label: 'Salidas', to: '/stock/salidas', iconKey: 'lista', permissions: 'STOCK_VER' },
    ] },
    { type: 'link', iconKey: 'transferencias', label: 'Nuevo traslado', to: '/stock/traslados/nuevo', permissions: 'STOCK_TRASLADO' },
    { type: 'link', iconKey: 'movimientos', label: 'Historial de movimientos', to: '/stock/movimientos', permissions: 'STOCK_VER' },
    { type: 'link', iconKey: 'transferencias', label: 'Transferencias', to: '/stock/transferencias', permissions: 'STOCK_TRASLADO' },
  ],
  'Mantenimiento de Flota': [
    {
      type: 'link',
      iconKey: 'vehiculos',
      label: 'Vehículos',
      to: '/administracion/flota',
    },
    {
      type: 'link',
      iconKey: 'mantenimiento',
      label: 'Taller',
      to: '/mantenimiento-flota',
      permissions: ['mantenimiento_flota.ver'],
    },
    {
      type: 'link',
      iconKey: 'mantenimiento',
      label: 'Listado de mantenimientos',
      to: '/mantenimiento-flota',
      permissions: ['mantenimiento_flota.ver'],
    },
    {
      type: 'link',
      iconKey: 'filePlus',
      label: 'Nuevo mantenimiento',
      to: '/mantenimiento-flota/nuevo',
      permissions: ['mantenimiento_flota.crear'],
    },
  ],
  Agencias: [
    { type: 'link', iconKey: 'agencias', label: 'Red de Agencias', to: '/agencias' },
    {
      type: 'section',
      iconKey: 'operaciones',
      label: 'Operaciones',
      items: [
        { label: 'Liquidaciones', to: '/agencias/liquidaciones', iconKey: 'liquidaciones' },
        { label: 'Convenios', to: '/agencias/convenios', iconKey: 'convenios' },
      ],
    },
    { type: 'link', iconKey: 'usuarios', label: 'Contactos', to: '/agencias/contactos' },
  ],
  Informes: [
    { type: 'link', iconKey: 'reportes', label: 'Tablero General', to: '/informes' },
    {
      type: 'section',
      iconKey: 'financieros',
      label: 'Financieros',
      items: [
        { label: 'Facturación y cobranzas', to: '/informes/financieros', iconKey: 'ingresosGastos' },
      ],
    },
    {
      type: 'section',
      iconKey: 'operativos',
      label: 'Operativos',
      items: [
        { label: 'Productividad', to: '/informes/productividad', iconKey: 'productividad' },
        { label: 'Clientes', to: '/informes/clientes', iconKey: 'usuarios' },
        { label: 'Choferes / Flota', to: '/informes/choferes', iconKey: 'choferes' },
      ],
    },
  ],
};

function normalizeLabel(label) {
  return (label || '').trim().toLowerCase();
}

function normalizePath(path) {
  return (path || '').trim().toLowerCase();
}

function cloneEntries(entries = []) {
  return entries.map(entry =>
    entry.type === 'section' && Array.isArray(entry.items)
      ? { ...entry, items: [...entry.items] }
      : { ...entry }
  );
}

function collectExistingItems(entries = []) {
  const existingLabels = new Set();
  const existingPaths = new Set();

  const register = item => {
    if (item?.label) {
      existingLabels.add(normalizeLabel(item.label));
    }
    if (item?.to) {
      existingPaths.add(normalizePath(item.to));
    }
  };

  entries.forEach(entry => {
    if (entry.type === 'section' && Array.isArray(entry.items)) {
      entry.items.forEach(register);
      return;
    }
    register(entry);
  });

  return { existingLabels, existingPaths };
}

export function mergeMenus(
  menuBaseDataInput,
  clipperCargasInput = [],
  clipperTesoreriaInput = [],
) {
  const nextMenu = Object.fromEntries(
    Object.entries(menuBaseDataInput).map(([moduleKey, entriesList]) => [
      moduleKey,
      cloneEntries(entriesList),
    ])
  );

  const cargasEntries = nextMenu.Cargas ?? [];
  const { existingLabels, existingPaths } = collectExistingItems(cargasEntries);

  const registerItem = item => {
    existingLabels.add(normalizeLabel(item.label));
    existingPaths.add(normalizePath(item.to));
  };

  const upsertSection = section => {
    if (!section.items?.length) {
      return;
    }
    const existingSection = cargasEntries.find(
      entry => entry.type === 'section' && entry.label === section.label
    );

    if (existingSection) {
      existingSection.items.push(...section.items);
      return;
    }

    cargasEntries.push(section);
  };

  clipperCargasInput.forEach(section => {
    const sourceItems = section.items ?? section.children ?? [];
    const sectionItems = sourceItems.filter(item => {
      if (!item?.label || !item?.to) {
        return false;
      }
      const normalizedLabel = normalizeLabel(item.label);
      if (existingLabels.has(normalizedLabel) || existingPaths.has(normalizePath(item.to))) {
        return false;
      }
      registerItem(item);
      return true;
    });

    upsertSection({
      type: 'section',
      iconKey: section.iconKey ?? 'lista',
      label: section.label,
      items: sectionItems,
    });
  });

  nextMenu.Cargas = cargasEntries;

  const tesoreriaEntries = nextMenu['Tesorería'] ?? [];
  const { existingLabels: tesoreriaLabels, existingPaths: tesoreriaPaths } =
    collectExistingItems(tesoreriaEntries);

  const registerTesoreriaItem = item => {
    tesoreriaLabels.add(normalizeLabel(item.label));
    tesoreriaPaths.add(normalizePath(item.to));
  };

  const upsertTesoreriaSection = section => {
    if (!section.items?.length) {
      return;
    }
    const existingSection = tesoreriaEntries.find(
      entry => entry.type === 'section' && entry.label === section.label
    );

    if (existingSection) {
      existingSection.items.push(...section.items);
      return;
    }

    tesoreriaEntries.push(section);
  };

  clipperTesoreriaInput.forEach(section => {
    const sourceItems = section.items ?? section.children ?? [];
    const sectionItems = sourceItems.filter(item => {
      if (!item?.label || !item?.to) {
        return false;
      }
      const normalizedLabel = normalizeLabel(item.label);
      if (tesoreriaLabels.has(normalizedLabel) || tesoreriaPaths.has(normalizePath(item.to))) {
        return false;
      }
      registerTesoreriaItem(item);
      return true;
    });

    upsertTesoreriaSection({
      type: 'section',
      iconKey: section.iconKey ?? 'lista',
      label: section.label,
      items: sectionItems,
    });
  });

  nextMenu['Tesorería'] = tesoreriaEntries;
  return nextMenu;
}

const menuData = mergeMenus(menuBaseData, clipperCargas, clipperTesoreria);

export { menuBaseData };
export default menuData;
